import { QueryFunction } from "@tanstack/react-query";

import { OrderTimeline, RouteTimeline } from "@web-app/types";
import http from "@web-app/utils/http";

type QueryParams = {
  orderId: string;
};

type RouteQueryParams = {
  routeId: string;
};

export const getTimeline: QueryFunction<OrderTimeline[]> = async ({
  queryKey,
}) => {
  const [, params] = queryKey as [string, QueryParams];

  return http
    .get(`/orders/${params.orderId}/timeline`, { params })
    .then((response) => response.data.reverse());
};

export const getRouteTimeline: QueryFunction<RouteTimeline[]> = async ({
  queryKey,
}) => {
  const [, params] = queryKey as [string, RouteQueryParams];

  return http
    .get(`/routes/${params.routeId}/timeline`, { params })
    .then((response) => response.data.reverse());
};
